import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { SENSOR_DATA_API } from "../../Api";
import axios from "axios";

class Result {
    constructor({ param_id, param_name, unit_name, reading_value, reading_timestamp }) {
        this.param_id = param_id;
        this.param_name = param_name;
        this.unit_name = unit_name;
        this.reading_value = reading_value;
        this.reading_timestamp = reading_timestamp;
    }
}


const AnnouncementBanner = () => {
    const sliderRef = useRef(null);
    const [result, setResult] = useState([]);

    useEffect(() => {
        const fetchReadingsForParameters = async () => {
            try {
                const response = await axios.get(SENSOR_DATA_API);
                const data = response.data;
                const resultList = data.map((item) => new Result(item));
                setResult(resultList);
                console.log(resultList);
            } catch (error) {
                console.error('Error fetching sensor data:', error);
            }
        };

        fetchReadingsForParameters();

        const intervalId = setInterval(fetchReadingsForParameters, 60000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);


    const settings = {
        className: "ticker",
        infinite: true,
        slidesToShow: 6, 
        slidesToScroll: 1,
        speed: 3000,
        autoplay: true,
        autoplaySpeed: 0, 
        cssEase: "linear", 
        arrows: false, 
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    className: "ticker",
                    infinite: true,
                    slidesToShow: 3, 
                    slidesToScroll: 1,
                    speed: 3000,
                    autoplay: true,
                    autoplaySpeed: 0, 
                    cssEase: "linear", 
                    arrows: false, 
                },
            },
            {
                breakpoint: 600,
                settings: {
                    className: "ticker",
        infinite: true,
        slidesToShow: 2, 
        slidesToScroll: 1,
        speed: 4000,
        autoplay: true,
        autoplaySpeed: 0, 
        cssEase: "linear", 
        arrows: false, 
                },
            },
            {
                breakpoint: 480,
                settings: {
                    className: "ticker",
        infinite: true,
        slidesToShow: 2, 
        slidesToScroll: 1,
        speed: 3000,
        autoplay: true,
        autoplaySpeed: 0, 
        cssEase: "linear", 
        arrows: false, 
                },
            },
        ],
    };
    
    
    
    

    return (
        <div className="slider-container relative w-full">
            <Slider ref={sliderRef} {...settings}>
                {result.map((result, index) => (
                    <div key={index} className="flex justify-center items-center">
                        <div className="container mx-auto px-6 bg-transparent rounded-lg text-left justify-center flex items-center">
                            {/* Reading Value */}
                            <p className="text-4xl font-bold text-white">{Math.round(result.reading_value)}</p>
    
                            {/* Vertical Line and Unit/Parameter in Column */}
                            <div className="ml-2 flex flex-col justify-center">
                                {/* <span className="text-gray-300 text-4xl font-light">|</span> */}
                            </div>
    
                            {/* Unit and Parameter Name (Stacked) */}
                            <div className="ml-2 flex flex-col">
                                <span className="text-gray-300 text-sm font-medium">{result.unit_name}</span>
                                <span className="text-gray-400 text-xs">{result.param_name}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
    
            <style jsx>{`
                @keyframes blink {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0;
                    }
                }
            
                .blink {
                    animation: blink 2s linear infinite;
                    color: #4caf50;
                }
            `}</style>
        </div>
    );
    
    
};

export default AnnouncementBanner;